import { requiredRule, getRuleLen, phoneRule, emailRule } from '../../../../utils/rules';
import React from 'react';
import { Form, Input } from '@roo/roo';

const { Field } = Form;
const { Textarea } = Input;

export const stageArr = ['第一季度','第二季度','第三季度','第四季度']

export const Detail = function (props) {
  const { values } = props

  return (
    <div className='form-patch'>
      <Field
        required={true}
        label='立项依据及工作基础'
        name={`projectBackground`}
        rule={getRuleLen(1000,true)}
        layout='vertical'
        as={
          <Textarea
            className='apply-area'
            maxLength={1000}
            placeholder='描述项目目的、意义，申报机构与拟申报项目相关的工作经验、成果、制度机制、工作团队等。限1000字。'
          />
        }
      />
      <p className='desc'>{(values?.projectBackground||[]).length}/1000</p>
      <Field
        required={true}
        label='项目简介'
        rule={getRuleLen(2000,true)}
        name={`introduction`}
        layout='vertical'
        as={
          <Textarea
            className='apply-area'
            maxLength={2000}
            placeholder='描述项目内容、工艺方案、产品方案、装备方案，项目技术应用范围等。限2000字。'
          />
        }
      />
      <p className='desc'>{(values?.introduction||[]).length}/2000</p>
      <Field
        required={true}
        label='自主创新'
        rule={getRuleLen(2000,true)}
        name={`innovation`}
        layout='vertical'
        as={
          <Textarea
            className='apply-area'
            maxLength={2000}
            placeholder='描述项目技术路线，技术的创新性、可行性；核心技术应用及应用于本项目的知识产权情况、工艺核心部件、大数据供应链软件的自主化率等。限2000字。'
          />
        }
      />
      <p className='desc'>{(values?.innovation||[]).length}/2000</p>
      <Field
        required={true}
        label='项目可行性'
        rule={getRuleLen(2000,true)}
        name={`feasibility`}
        layout='vertical'
        as={
          <Textarea
            className='apply-area'
            maxLength={2000}
            placeholder='描述项目商业模式可行性及创新性：如外卖场景可落地性、是否已有应用案例等；项目立项批准情况：如项目城乡规划、用地审批（如涉及）、节能审查、环评等前期手续（如需）；项目投融资情况及行业机构、地方政府参与支持情况等，限2000字。'
          />
        }
      />
      <p className='desc'>{(values?.feasibility||[]).length}/2000</p>
     <Field
        required={true}
        label='预期成果效益'
        rule={getRuleLen(1000,true)}
        name={`achievement`}
        layout='vertical'
        as={
          <Textarea
            className='apply-area'
            maxLength={1000}
            placeholder='描述预期经济效益：如预期经济收益及实现规模化能力、经验模式可复制推广性、投入产出比和利润情况等；描述预期社会环境效益: 如对外卖包装减塑及行业减排的作用、是否解决行业关键技术和装备中的“卡脖子”问题或重大需求等，限1000字。'
          />
        }
      />
      <p className='desc'>{(values?.achievement||[]).length}/1000</p>
      <Field
        required={true}
        label='示范性年度实施进度计划'
        name={`stages`}
        layout='vertical'
        rule={{
            validator: (rule, value, callback) => {
              if (!value) {
                return callback('请填写年度实施进度计划');
              }
              if (value.length!==4) {
                return callback('请完整填写进度计划');
              }
              if (value.length===4) {
                  value.forEach(item => {
                      if (item.task == null || item.achievement == null){
                          return callback('请完整填写进度计划');
                      }
                  })
              }
              return callback();
            },
        }}
      >
        <div className={'cert-table'}>
            <div className={'c-title'}>时间节点</div>
            <div className={'c-title'}>任务</div>
            <div className={'c-title'}>成果形式</div>
            {
                (stageArr || []).map((item,index) => {
                    return <StageItem stage={item} key={item} idx={index} {...props}></StageItem>
                })
            }
        </div>
      </Field>
      <br />
    </div>
  );
};

export const StageItem = (props) => {
    const { stage, idx, setFieldValue, values, disabled } = props
    const taskContent = values?.stages?.[idx]?.task || '';
    const achievementContent = values?.stages?.[idx]?.achievement || '';
    return (
      <>
        <div className={'c-time'}>{stage}</div>
        <div className={'c-task'} style={{position:"relative"}}>
          <Textarea
            className={'c-area'}
            resize='none'
            maxLength={300}
            placeholder='请输入本季度的项目关键任务，限300字'
            value = {taskContent}
            disabled={disabled}
            onChange={(e) => {
              setFieldValue(`stages.${idx}.task`, e.currentTarget.value);
            }}
          ></Textarea>
          <p className='t-desc'>{(values?.stages?.[idx]?.task||[]).length}/300</p>
        </div>
        <div className={'c-achievement'} style={{position:"relative"}}>
          <Textarea
            className={'c-area'}
            resize='none'
            maxLength={300}
            placeholder='请描述本季度计划拿到的成功即形式，限300字。'
            value = {achievementContent}
            disabled={disabled}
            onChange={(e) => {
              setFieldValue(`stages.${idx}.achievement`, e.currentTarget.value);
            }}
          ></Textarea>
          <p className='t-desc'>{(values?.stages?.[idx]?.achievement||[]).length}/300</p>
        </div>
      </>
    );
}